"use client";

import { useId } from "react";

export function AttestShield({ className, label = "肖像版权守护与身份认证示意" }: { className?: string; label?: string }) {
  const id = useId();
  return (
    <svg viewBox="0 0 460 370" width={460} height={370} className={className} role="img" aria-labelledby={`${id}-title`}>
      <title id={`${id}-title`}>{label}</title>
      <defs>
        <linearGradient id={`${id}-body`} x1="0" y1="0" x2="1" y2="1">
          <stop stopColor="var(--color-brand-light)" />
          <stop offset=".48" stopColor="var(--color-brand)" />
          <stop offset="1" stopColor="var(--color-brand-hover)" />
        </linearGradient>
        <linearGradient id={`${id}-rim`} x1="0" y1="0" x2="1" y2="1">
          <stop stopColor="#fff" />
          <stop offset=".45" stopColor="color-mix(in srgb, var(--color-brand-light) 35%, white)" />
          <stop offset="1" stopColor="var(--color-brand-light)" />
        </linearGradient>
        <linearGradient id={`${id}-light`} x1="0" y1="0" x2="1" y2="1">
          <stop stopColor="#fff" stopOpacity=".26" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <filter id={`${id}-shadow`} x="-60%" y="-40%" width="220%" height="210%">
          <feDropShadow dx="0" dy="19" stdDeviation="17" floodColor="var(--color-brand)" floodOpacity=".2" />
        </filter>
      </defs>
      <circle cx="230" cy="180" r="148" fill="none" stroke="color-mix(in srgb, var(--color-brand-light) 35%, white)" />
      <circle cx="230" cy="180" r="125" fill="none" stroke="color-mix(in srgb, var(--color-brand-light) 35%, white)" strokeDasharray="3 8" />
      <ellipse cx="230" cy="197" rx="202" ry="70" transform="rotate(-18 230 197)" fill="none" stroke="color-mix(in srgb, var(--color-brand-light) 35%, white)" />
      <g filter={`url(#${id}-shadow)`}>
        <path d="M230 48C201 68 173 79 132 87V181C132 248 174 288 230 315C286 288 328 248 328 181V87C287 79 259 68 230 48Z" fill={`url(#${id}-rim)`}/>
        <path d="M230 58C201 77 178 86 141 95V181C141 242 179 280 230 305C281 280 319 242 319 181V95C282 86 259 77 230 58Z" fill={`url(#${id}-body)`}/>
        <path d="M230 76C206 91 183 100 157 107V180C157 232 188 265 230 288C272 265 303 232 303 180V107C277 100 254 91 230 76Z" fill="none" stroke="color-mix(in srgb, var(--color-brand-light) 35%, white)" strokeOpacity=".5" />
        <path d="M230 59C201 77 178 86 141 95V181C141 218 157 249 180 271L276 82C259 75 244 67 230 59Z" fill={`url(#${id}-light)`}/>
        <circle cx="230" cy="167" r="43" fill="#fff" fillOpacity=".1" stroke="#fff" strokeOpacity=".3" />
        <path d="M209 167L224 182L252 150" fill="none" stroke="#fff" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M207 234H253M216 244H244" stroke="color-mix(in srgb, var(--color-brand-light) 35%, white)" strokeOpacity=".65" strokeWidth="3" strokeLinecap="round" />
      </g>
      <g fill="#fff" stroke="color-mix(in srgb, var(--color-brand-light) 35%, white)">
        <rect x="54" y="111" width="48" height="48" rx="14" />
        <rect x="356" y="227" width="48" height="48" rx="14" />
      </g>
      <g fill="none" stroke="var(--color-brand)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="66" y="126" width="24" height="18" rx="4" />
        <circle cx="74" cy="133" r="2.5" />
        <path d="M70 140Q74 135 78 140M82 131H86M82 136H86" />
        <rect x="370" y="247" width="20" height="15" rx="3" />
        <path d="M374 247V243A6 6 0 0 1 386 243V247M380 253V256" />
      </g>
      <circle cx="357" cy="98" r="6" fill="var(--color-brand)" stroke="#fff" strokeWidth="3" />
      <circle cx="111" cy="282" r="5" fill="var(--color-brand-light)" stroke="#fff" strokeWidth="3" />
    </svg>
  );
}
